/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_BackInputs */

const cs_documents_back = /** @type {(inputs: Documents_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na dokumenty`)
};

const en_documents_back = /** @type {(inputs: Documents_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to documents`)
};

/**
* | output |
* | --- |
* | "Back to documents" |
*
* @param {Documents_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_back = /** @type {((inputs?: Documents_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_back(inputs)
	return cs_documents_back(inputs)
});